import type { Template } from '../../lib/templates';

interface HostRailSectionsProps {
  template: Template;
  currentSectionId: number | null;
  onSetSection: (sectionId: number | null) => void;
  pending: boolean;
}

/** Numbered eyebrows, current one lime — clicking the current section again clears it. */
export function HostRailSections({ template, currentSectionId, onSetSection, pending }: HostRailSectionsProps) {
  const sections = [...template.sections].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <section>
      <div className="flex items-baseline gap-4">
        <span className="eyebrow">03 / Section</span>
        <span className="h-px flex-1 bg-border" aria-hidden="true" />
      </div>
      <ul className="mt-3 flex flex-col gap-1.5">
        {sections.map((section, index) => {
          const isCurrent = section.id === currentSectionId;
          return (
            <li key={section.id}>
              <button
                type="button"
                disabled={pending}
                aria-pressed={isCurrent}
                aria-label={`Set current section: ${section.name}`}
                onClick={() => onSetSection(isCurrent ? null : section.id)}
                className={[
                  'flex min-h-tap w-full items-center gap-2 rounded-md border px-3 text-sm font-semibold transition-colors disabled:opacity-50',
                  isCurrent
                    ? 'border-accent bg-accent-dim text-accent'
                    : 'border-border-strong text-text-muted hover:text-text',
                ].join(' ')}
              >
                <span className="eyebrow">{String(index + 1).padStart(2, '0')}</span>
                <span className="flex-1 text-left">{section.name}</span>
                {isCurrent && <span className="telemetry">live</span>}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
